module.exports = __webpack_public_path__ + "static/media/homeBg.7e30ae7d.webp";